module.exports = __webpack_public_path__ + "img/favorites-dashboard-homeicon.d5598023.png";